import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  salas:[],
};
export const mutations = {
  FILL_SALAS({ context }, salas) {
    let lista_salas = [];
    if (salas) {
      Object.entries(salas).forEach(([key, val]) => lista_salas.push(val));
      return (state.salas = lista_salas);
    }
  }
};
export const actions = {
    GET_SALAS({ commit }, data) {
        return new Promise((resolve, reject) => {
          commit("SET_LOADING", true);
          ApiService.get(data)
            .then(response => {
              commit("SET_LOADING", false);
              commit("FILL_SALAS", response.data.data.salas);
              resolve(response);
            })
            .catch(error => {
              commit("SET_LOADING", false);
              reject(error);
            });
        });
      },
  SAVE_SALA({ commit }, sala) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(sala)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_SALA({ commit }, dataSala) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(dataSala)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_SALA({ commit }, sala_id) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(sala_id)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};

export const getters = {
  listSalas: state => state.salas,
};
